import { HYDRATE } from "next-redux-wrapper";
import { ActionsProductMatches } from "./actions";

const initialState = {
	data: [],
	meta: {},
	is_loading: false,
	error: null,
	status: "fetch_init",
	message: "",
};

function storeProductMatches(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeProductMatches };
	case ActionsProductMatches.LOAD_GET_PRODUCT_MATCHES:
		return {
			...state,
			status: "fetch_loading",
			is_loading: true,
			error: null,
		};
	case ActionsProductMatches.RES_GET_PRODUCT_MATCHES:
		return {
			...state,
			data: action.data.data,
			meta: action.data.meta,
			status: "fetch_result",
			is_loading: false,
			error: null,
		};
	case ActionsProductMatches.ERR_GET_PRODUCT_MATCHES:
		return {
			...state,
			data: [],
			meta: {},
			status: "fetch_error",
			message: "Error...",
			is_loading: false,
			error: true,
		};
	default:
		return { ...state };

	}

}

export default storeProductMatches;
